import { useMemo } from "react";
import { Room } from "livekit-client";
import { useParticipants } from "@livekit/components-react";
import { Mic, MicOff, Video, VideoOff, User } from "lucide-react";
import { cn } from "@/lib/utils";

interface ParticipantsGridProps {
  room: Room;
}

export function ParticipantsGrid({ room }: ParticipantsGridProps) {
  const participants = useParticipants();

  const allParticipants = useMemo(() => {
    return [
      room.localParticipant,
      ...Array.from(room.remoteParticipants.values()),
    ];
  }, [room, participants]);

  return (
    <div className="flex h-full flex-col bg-[#1f1f1f] border-l border-border">
      <div className="border-b border-border px-4 py-3">
        <h3 className="font-semibold text-foreground">
          Người tham gia ({allParticipants.length})
        </h3>
      </div>

      <div className="flex-1 overflow-y-auto p-4">
        <div className="grid grid-cols-2 gap-3">
          {allParticipants.map((participant) => {
            const isLocal = participant.identity === room.localParticipant.identity;
            const name = participant.name || participant.identity || "Unknown";
            const isMicEnabled = participant.isMicrophoneEnabled;
            const isCameraEnabled = participant.isCameraEnabled;

            return (
              <div
                key={participant.identity}
                className={cn(
                  "relative flex flex-col items-center justify-center rounded-lg border bg-[#2a2a2a] p-4 aspect-square",
                  isLocal && "ring-2 ring-primary"
                )}
              >
                <div className="mb-2 flex size-16 items-center justify-center rounded-full bg-muted">
                  <User className="size-8 text-muted-foreground" />
                </div>
                <div className="text-center">
                  <div className="text-sm font-medium text-foreground truncate max-w-full">
                    {name}
                  </div>
                  <div className="mt-2 flex items-center justify-center gap-2">
                    {isMicEnabled ? (
                      <Mic className="size-4 text-green-500" />
                    ) : (
                      <MicOff className="size-4 text-muted-foreground" />
                    )}
                    {isCameraEnabled ? (
                      <Video className="size-4 text-green-500" />
                    ) : (
                      <VideoOff className="size-4 text-muted-foreground" />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

